import type { VoidFunctionComponent } from 'react';

type Props = {
  isSmallIcon?: boolean;
};

/* eslint-disable react/no-unknown-property */
const NpmIcon: VoidFunctionComponent<Props> = ({ isSmallIcon }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={isSmallIcon ? 12 : 16} height={isSmallIcon ? 12 : 16} fill="none" viewBox="0 0 80 80"><g clip-path="url(#a)"><path fill="#CB3837" d="M0 0h80v80H0z" /><path fill="#fff" d="M14 67V14h53v53H53.75V27.25H40.5V67H14Z" /></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h80v80H0z" /></clipPath></defs></svg>
  );
};

export default NpmIcon;
